import React, { useState, useReducer, useEffect } from 'react';
import CustomTextField from '../../../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { fetchAllInRoomDining, inRoomDiningCustomisationsSelector } from '../../../servicesSlice';
import { useSelector, useDispatch } from 'react-redux';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { FormControlLabel, Radio, RadioGroup, Button, IconButton } from '@material-ui/core';
import { formDataValidate } from '../../../../../utils/formUtils';
import { addInRoomDiningCustomisation } from '../../../../../utils/ServicesAPIUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import AddNewPopUPModel from '../../../../../shared/add-new-popup/Add-New-Popup-Model';
import CustomChipInput from './../../../../../shared/form-controls/custom-chip-input/Custom-Chip-Input';
import EditIcon from '@mui/icons-material/Edit';
import './item-Create-Customisation.scss';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const ItemCreateCustomisation = (props) => {
  const {
    formData,
    setFormData,
    onChangeRadioButton,
    hotelId,
    restaurantId,
    customisationError,
    setCustomisationError,
    validate,
    showLoader = () => {},
  } = props;
  const [customisationToMap, setCustomisationToMap] = useState([]);
  const [isEditCustomisation, setIsEditCustomisation] = useState({
    isEdit: false,
    customIndex: -1,
  });
  const originalCustomisations = useSelector(inRoomDiningCustomisationsSelector);
  const [addNewValues, setAddNewValues] = useState({
    title: '',
    status: false,
  });
  const dispatch = useDispatch();

  useEffect(() => {
    setCustomisationToMap(formData.customisationArray.value);
  }, []);

  const [customisationFormData, setCustomisationFormData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      name: {
        value: '',
        fieldName: 'Customisation Name',
        errors: {},
        validations: ['required'],
      },
      code: {
        value: '',
        fieldName: 'Customisation Code',
        errors: {},
        validations: ['required', 'validAlphaNumeric'],
      },
      status: {
        value: true,
        fieldName: 'Active',
        errors: {},
        validations: [],
      },
    },
  );

  const renderModelCustomisation = () => {
    return (
      <div>
        <div className='mx-4'>
          <div className='col-md-12 mb-3'>
            <CustomTextField
              item={customisationFormData.name}
              handleInputChange={(e) => {
                setCustomisationFormData({ name: e });
              }}
              maxLength={60}
              endAdornment={true}
              characterCount={true}
            />
          </div>
          <div className='col-md-12 mb-3'>
            <CustomTextField
              item={customisationFormData.code}
              handleInputChange={(e) => {
                setCustomisationFormData({ code: e });
              }}
              maxLength={8}
            />
          </div>
        </div>
      </div>
    );
  };

  const validateCustomisationFormData = () => {
    const updatedFields = {};
    const isValid = formDataValidate(customisationFormData, updatedFields);
    setCustomisationFormData(updatedFields);
    return isValid;
  };

  const onCLickAddCustomisation = async () => {
    if (hotelId && validateCustomisationFormData()) {
      try {
        dispatch(stepUpLoaderCount());
        const selectedLanguage = decryptLocalStorage('lang');
        const language = selectedLanguage !== 'en' ? selectedLanguage : '';
        const payload = {
          name: customisationFormData.name.value,
          code: customisationFormData.code.value,
          status: customisationFormData.status.value,
          hotelId: hotelId,
          restaurantId: restaurantId,
        };
        const resp = await addInRoomDiningCustomisation(payload, language);
        const customisationIdFormData = formData.ingredientCustomisationId;
        const updateCustomisationId = [
          ...customisationIdFormData.value,
          resp.data.createIRDCustomisation.id,
        ];
        customisationIdFormData.value = [...updateCustomisationId];
        setFormData({ ingredientCustomisationId: customisationIdFormData });
        notificationManager('success', 'Customisation created successfully');
        customisationFormData.name.value = '';
        customisationFormData.code.value = '';
        dispatch(fetchAllInRoomDining(hotelId, restaurantId));
        formData.ingredientCustomisationId.errors = { required: null };
        handlePopupClose();
      } catch (error) {
        if (error?.graphQLErrors) {
          notificationManager('danger', error?.graphQLErrors?.[0]?.message);
        } else {
          notificationManager('danger', 'Customisation creation failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
      handlePopupClose();
    }
  };

  const openCustomisationModal = (textFieldValue) => {
    setAddNewValues({
      title: 'Customisation',
      status: true,
    });
    const nameFieldCustomisationFormData = { ...customisationFormData.name };
    nameFieldCustomisationFormData.value = textFieldValue;
    setCustomisationFormData({ name: nameFieldCustomisationFormData });
  };

  const handlePopupClose = () => {
    setAddNewValues({
      title: '',
      status: false,
    });
    const resetCustomisationFormData = { ...customisationFormData };
    resetCustomisationFormData.name.value = '';
    resetCustomisationFormData.code.value = '';
    setCustomisationFormData(resetCustomisationFormData);
  };

  const onAddCustomisation = () => {
    const ingredient = formData.customisationIngredient.value;
    const customisations = formData.ingredientCustomisationId.value;
    if (ingredient && customisations?.length > 0) {
      setCustomisationError(false);
      const currentInput = {
        ingredient,
        customisations,
      };
      if (isEditCustomisation.isEdit) {
        const currField = { ...formData.customisationArray };
        const customisationData = [...currField.value];
        customisationData[isEditCustomisation.customIndex] = currentInput;
        currField.value = customisationData;
        setCustomisationToMap(customisationData);
        setFormData({ customisationArray: currField });
        setIsEditCustomisation({ isEdit: false, customIndex: -1 });
      } else {
        const currField = { ...formData.customisationArray };
        const ingredientIndex = currField.value.findIndex(
          (customisation) => customisation.ingredient === ingredient,
        );
        if (ingredientIndex === -1) {
          const customisationData = [...currField.value, currentInput];
          setCustomisationToMap(customisationData);
          currField.value = customisationData;
          setFormData({ customisationArray: currField });
        } else {
          const customisationData = [...currField.value];
          customisationData[ingredientIndex] = currentInput;
          setCustomisationToMap(customisationData);
          currField.value = customisationData;
          setFormData({ customisationArray: currField });
        }
      }
      formData.customisationIngredient.value = '';
      formData.ingredientCustomisationId.value = [];
    }
  };

  const getCustomisationForIngredient = (customisationsForIngredient) => {
    const customisationArray = originalCustomisations?.filter((customisation) => {
      return customisationsForIngredient?.includes(customisation?.id);
    });
    return (
      <div className='row d-inline-flex'>
        {customisationArray
          ?.map((item) => {
            return item?.name;
          })
          ?.join(', ')}
      </div>
    );
  };

  const onClickEditCustomisation = async (e, customisationKey, customisationIndex) => {
    e.preventDefault();
    setIsEditCustomisation({ isEdit: true, customIndex: customisationIndex });
    formData.customisationIngredient.value = customisationKey.ingredient;
    formData.ingredientCustomisationId.value = customisationKey.customisations;
  };

  const onDeleteCustomisation = (e, customisationIndex) => {
    e.preventDefault();
    const currField = { ...formData.customisationArray };
    const cstm = [...currField.value];
    setCustomisationToMap(cstm);
    cstm.splice(customisationIndex, 1);
    currField.value = cstm;
    setFormData({ customisationArray: currField });
  };

  const onChangeCustomisationStatus = (e, fieldName) => {
    setCustomisationError(false);
    formData.customisationArray.validations = e.target.value === 'inactive' ? [] : ['required'];
    onChangeRadioButton(e, fieldName);
  };

  return (
    <div className='row px-3 w-100 d-flex mt-4'>
      {addNewValues && addNewValues.status === true && (
        <AddNewPopUPModel
          addNewPopUp={addNewValues}
          onClickAdd={onCLickAddCustomisation}
          onClickCancel={handlePopupClose}
          renderModel={renderModelCustomisation}
          formData={customisationFormData}
        />
      )}
      <div className='row'>
        <h4 className='tab-title'>Customisation</h4>
        <div className='col-md-12 mb-3'>
          <RadioGroup
            row
            aria-label={formData.customisationStatus.fieldName}
            onChange={(e) => {
              onChangeCustomisationStatus(e, 'customisationStatus');
            }}
            value={formData.customisationStatus.value}
            name={formData.customisationStatus.fieldName}
            className='document-type mb-3'
          >
            <FormControlLabel
              value='active'
              control={<Radio color='primary' />}
              label='Active'
              className='col-md-4'
            />
            <FormControlLabel
              value='inactive'
              control={<Radio color='primary' />}
              label='Inactive'
              className='col-md-4'
            />
          </RadioGroup>
        </div>
      </div>
      {formData.customisationStatus.value === 'active' && (
        <div>
          <div className='row'>
            <div className='col-md-12 mb-3'>
              <div className='col-md-6 mb-3'>
                <CustomTextField
                  item={formData.customisationIngredient}
                  handleInputChange={(e) => {
                    setFormData({ customisationIngredient: e });
                  }}
                  maxLength={50}
                  endAdornment={true}
                  characterCount={true}
                />
              </div>
            </div>
          </div>
          <div className='row mb-3'>
            <CustomChipInput
              options={Object.assign(
                [],
                originalCustomisations?.filter((customisation) => customisation?.status === true),
              )}
              labelField='name'
              textFieldLabel='Customisations'
              textFieldPlaceholder='Select Customisation'
              isAddNewEnabled={true}
              onClickAddNew={openCustomisationModal}
              formData={formData}
              setFormData={setFormData}
              formField='ingredientCustomisationId'
            />
          </div>
          <div className='me-3 col-md-4 row mt-2 mb-2'>
            <Button
              variant='outlined'
              color='primary'
              disabled={
                (formData?.customisationIngredient?.value?.length ?? 0) === 0 ||
                (formData?.ingredientCustomisationId?.value?.length ?? 0) === 0
              }
              onClick={onAddCustomisation}
              size='large'
              className='me-3 col-md-4'
            >
              Add
            </Button>
          </div>
          {customisationError && formData?.customisationArray?.value?.length === 0 && (
            <p style={{ color: 'red' }}>Ingredient Customisation is required</p>
          )}
          {customisationToMap && customisationToMap?.length > 0 && (
            <div className='col-md-12 mt-3'>
              {customisationToMap?.map((customisationKey, customisationIndex) => (
                <div
                  className='row details-value d-flex mt-2 mb-2 customDisplay p-1'
                  key={customisationIndex}
                >
                  <div className='col-md-10 ml-2'>
                    <span className='ingredientName'>{customisationKey.ingredient}: </span>
                    <span> {getCustomisationForIngredient(customisationKey.customisations)}</span>
                  </div>
                  <div className='col-md-1'>
                    <IconButton
                      aria-label='edit'
                      disabled={isEditCustomisation.isEdit}
                      onClick={(e) =>
                        onClickEditCustomisation(e, customisationKey, customisationIndex)
                      }
                    >
                      <EditIcon fontSize='12' className='icon' />
                    </IconButton>
                  </div>
                  <div className='col-md-1'>
                    <IconButton
                      aria-label='delete'
                      onClick={(e) => onDeleteCustomisation(e, customisationIndex)}
                    >
                      <RemoveCircleIcon fontSize='12' className='icon' />
                    </IconButton>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ItemCreateCustomisation;
